/**
 * Pestaña Configuración.
 *
 * Secciones de la misma pantalla: lo que el portal necesita saber para
 * liquidar —feriados y diccionario de conceptos— y el alcance de Asistencia al
 * Viaje. Van como sub-solapas y no como pestañas del portal porque son
 * configuración de lo mismo, no lugares distintos.
 */

import { useState } from 'react';

import { BookMarked, CalendarDays, Route } from 'lucide-react';

import { PanelAsistencia } from './PanelAsistencia';
import { PanelConceptos } from './PanelConceptos';
import { PanelFeriados } from './PanelFeriados';

type Solapa = 'feriados' | 'conceptos' | 'asistencia';

const SOLAPAS = [
  { clave: 'feriados', etiqueta: 'Feriados', icono: CalendarDays },
  { clave: 'conceptos', etiqueta: 'Diccionario de conceptos', icono: BookMarked },
  { clave: 'asistencia', etiqueta: 'Asistencia al Viaje', icono: Route },
] as const;

export function VistaConfiguracion(): React.JSX.Element {
  const [solapa, setSolapa] = useState<Solapa>('feriados');

  return (
    <div className="configuracion">
      <header className="seccion-encabezado">
        <h1>Configuración</h1>
        <p className="nota">
          Lo que el portal necesita saber para liquidar: qué días son feriado, a qué concepto de
          Visma va cada cosa que se cuenta del TMS, y sobre qué grupos corre Asistencia al Viaje.
        </p>
      </header>

      <div className="subsolapas" role="tablist" aria-label="Secciones de configuración">
        {SOLAPAS.map(({ clave, etiqueta, icono: Icono }) => (
          <button
            key={clave}
            type="button"
            role="tab"
            aria-selected={solapa === clave}
            className={`subsolapa${solapa === clave ? ' activa' : ''}`}
            onClick={() => setSolapa(clave)}
          >
            <Icono size={15} aria-hidden="true" />
            {etiqueta}
          </button>
        ))}
      </div>

      {/* Cada panel recarga lo suyo al abrirse: son consultas cortas contra
          la base del portal, no vale la pena conservar el estado. */}
      {solapa === 'feriados' && <PanelFeriados />}
      {solapa === 'conceptos' && <PanelConceptos />}
      {solapa === 'asistencia' && <PanelAsistencia />}
    </div>
  );
}
